import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type ExchangeAgentGuidanceFlatTeamSettingGroupId =
  "exchange_agent_guidance.overview";

// Guidance rules live in their own CRDB table behind the
// exchange-agent-guidance repo, not in team.settings.
const exchangeAgentGuidanceOwner: SettingOwner = {
  kind: "crdb",
  product: "returns",
};

const exchangeAgentGuidanceRisk: SettingRisk = {
  level: "medium",
  reason: "Exchange agent guidance shapes AI exchange behavior.",
};

export const ExchangeAgentGuidanceFlatTeamSettingGroups = [
  {
    id: "exchange_agent_guidance.overview",
    title: "Exchange agent guidance",
    description: "Guidance rules for the AI exchange agent.",
    productArea: "returns",
    access: directMerchantAccess(
      SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
    ),
    owner: exchangeAgentGuidanceOwner,
    risk: exchangeAgentGuidanceRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "customer-portal/guidance" },
    synonyms: [
      "exchange agent guidance",
      "agent guidance",
      "exchange guidance",
      "product recommendation",
      "exchange recommendations",
      "AI exchange rules",
    ],
  },
] as const satisfies readonly SettingGroupDefinition<ExchangeAgentGuidanceFlatTeamSettingGroupId>[];
